/**
 * Lesson versioning endpoints.
 */
import type {
  ActivateVersionResponse,
  StagedStateResponse,
  VersionContentResponse,
  VersionListResponse,
} from '@/types/api';
import { apiClient } from './client';

/**
 * Versioning Types
 */

/**
 * Versioning API endpoints
 */
export const versionApi = {
  /** List all versions for a lesson */
  listVersions: (lessonId: string) =>
    apiClient.get<VersionListResponse>(`/lessons/${lessonId}/versions`),

  /** Get content for a specific version */
  getVersionContent: (lessonId: string, version: string) =>
    apiClient.get<VersionContentResponse>(
      `/lessons/${lessonId}/versions/${version}/content`
    ),

  /** Switch to a specific version */
  activateVersion: (lessonId: string, version: string) =>
    apiClient.post<ActivateVersionResponse>(
      `/lessons/${lessonId}/versions/${version}/activate`
    ),

  /**
   * Replace the staged source selection (checkbox state). Sends the full
   * intended array; backend validates each id is an active source on this
   * lesson.
   */
  putStagedSources: (lessonId: string, sourceIds: string[]) =>
    apiClient.put<StagedStateResponse>(`/lessons/${lessonId}/staged-sources`, {
      source_ids: sourceIds,
    }),

  /** Reset staged source selection + draft prompt to match the current version. */
  discardStaged: (lessonId: string) =>
    apiClient.post<StagedStateResponse>(`/lessons/${lessonId}/discard-staged`),
};
